export const ACCESS_CONTROL = {
    "peltask": 1,
    "mym": 2,
    "medsheets" : 1,
    "medsheet"  : 1,
    "medsheets_advanced": 2,
    "treament": 2,
    "currentmeds": 2,
    "loaform": 2,
    "hcporder": 2,
    "editprescription" : 2,
    "medtrackui": 1,
    "telephoneorder": 2,
    "tansferform": 2,
    "currentmedlist": 2,
    "patientprofile": 1,
    "dayprogramactive" : 4
}

// SharedLiving caregiver = role 7. These are page-level allow/deny lists keyed
// by role id, used to gate the sidebar and to back the 403 fallback. Role 7 is
// tightly scoped: My Patients, MedPass, the 7 caregiver reports, own profile.
export const ROLE_CAREGIVER = 7;

// Pages a SharedLiving caregiver (role 7) is allowed to reach.
export const CAREGIVER_ALLOWED_PATH_KEYS = [
  'caregiverMyPatients',
  'caregiverPatientDetail',
  'caregiverReports',
  'medpassdashboard',
  'medpassreport',
  'UserProfile',
  'defaultSetting',
  'mobileSetting',
  'notification',
  'accessDenied'
];

// Top-level URL path fragments a caregiver must never reach (mirrors backend
// ROLE_7_BLOCKED_PREFIXES). Used by the 403 fallback / route guard.
export const CAREGIVER_BLOCKED_PATH_FRAGMENTS = [
  '/admin/',
  '/groups/',
  '/route4me/',
  '/peltask/cycle',
  '/peltask/hold',
  '/peltask/order',
  '/hcp/',
  '/day-program/',
  '/prescription/add',
  '/prescription/edit'
];

export const isCaregiverPathAllowed = pathname => {
  if (!pathname) return false;
  return !CAREGIVER_BLOCKED_PATH_FRAGMENTS.some(fragment =>
    pathname.includes(fragment)
  );
};